import React from 'react';

/** Single user icon with plus badge in the corner (matches add-group empty tile). */
function MemberAddIcon() {
  return (
    <>
      <svg
        className="groups-add-group-empty__users"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
      <span className="groups-add-group-empty__icon-plus" aria-hidden>
        +
      </span>
    </>
  );
}

/**
 * Empty members placeholder — dashed card with user icon and “Add a member”.
 */
const GroupsAddMemberEmptyState = ({ onClick, disabled = false, className = '' }) => {
  const interactive = Boolean(onClick) && !disabled;
  const Tag = interactive ? 'button' : 'div';

  return (
    <Tag
      type={interactive ? 'button' : undefined}
      className={[
        'groups-add-group-empty',
        interactive ? 'groups-add-group-empty--interactive' : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={interactive ? onClick : undefined}
      disabled={Tag === 'button' ? disabled : undefined}
      aria-label={interactive ? 'Add a member' : undefined}
      title={interactive ? 'Add a member' : undefined}
    >
      <span className="groups-add-group-empty__icon" aria-hidden>
        <MemberAddIcon />
      </span>
      <span className="groups-add-group-empty__label">Add a member</span>
    </Tag>
  );
};

export default GroupsAddMemberEmptyState;
